<div>
  <a class="tp-logo-link" href="https://typedb.com" target="_blank">
    <img class="tp-logo" src="https://typedb.com/assets/logo/typedb.svg" alt="TypeDB"/>
  </a>
  <p class="box-title">Set up MFA for your account</p>
  @if (settingUpMfa) {
    <tp-mfa-setup [cancellable]="false" (mfaSuccess)="nextPage()"></tp-mfa-setup>
  } @else {
    <p class="box-text">
      Multi-factor authentication helps keep your account secure.
      We strongly recommend setting it up now.
    </p>
    <tp-button (click)="settingUpMfa = true" buttonId="setUpMfa" buttonStyle="primary-outline green stroke">Set up MFA now</tp-button>
  }
  <br/>
  <div style="display: flex;">
    <div class="flex-spacer"></div>
    <a routerLink="/setup">
      <tp-button class="skip-mfa-setup-button" buttonId="skipMfaSetup" buttonStyle="secondary">Do this later →</tp-button>
    </a>
  </div>
</div>
